import { toFixedMax } from "./numberHelpers";

export const formatUptime = (seconds: number | undefined): string => {
    if (seconds === undefined || seconds === null || seconds <= 0) return "—";

    const minutes = seconds / 60.0;
    const hours = minutes / 60.0;
    const days = hours / 24.0;

    if (days >= 1) {
        return `${toFixedMax(days, 1)} Days`;
    } else if (hours >= 1) {
        return `${toFixedMax(hours, 1)} Hours`;
    } else if (minutes >= 1) {
        return `${toFixedMax(minutes, 1)} Mins`;
    } else {
        return `${toFixedMax(seconds, 0)} Secs`;
    }
};

export const getAverageCpuUsage = (coreUsages: number[] | undefined): number | undefined => {
    if (!coreUsages || coreUsages.length < 1) return undefined;
    const total = coreUsages.reduce((sum, val) => sum + val, 0);
    return total / coreUsages.length;
};

export const isValidHumidity = (humidity: number | undefined): humidity is number => {
    return humidity !== undefined && humidity >= 1 && humidity <= 100;
};

export const isValidCellSignal = (signal: number | undefined): signal is number => {
    return signal !== undefined && signal >= 1 && signal <= 100;
};

export interface HardwareStatusCardData {
    status: string;
    statusHoverText?: React.ReactNode;
    cpuUsage?: number;
    uptime?: number;
    cellSignal?: number;
    humidity?: number;
    isDisconnected?: boolean;
    lastHeartbeat?: string;
}
